export class Yashare {
    constructor($block) {
        if(!$block.length) return;

        $.each($block, function(i, item) {
            if ($(item).hasClass('inited')) return;
            window.Ya.share2(item, {
                theme: {
                    services: 'vkontakte,telegram',
                    lang: 'ru',
                    size: 'l',
                    shape: 'round',
                    bare: false
                }
            });

            $(item).addClass('inited');
        });

    }
}
